var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__wrapper" }, [
    _c(
      "div",
      {
        staticClass: "text__wrapper",
        style: { width: _vm.align === "center" ? "100%" : "95%" }
      },
      [
        _vm.header.title
          ? _c(
              "h2",
              {
                directives: [{ name: "balancetext", rawName: "v-balancetext" }],
                style: { textAlign: _vm.align }
              },
              [_vm._v("\n      " + _vm._s(_vm.header.title) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.header.intro
          ? _c(
              "p",
              {
                directives: [{ name: "balancetext", rawName: "v-balancetext" }],
                staticClass: "sans__reg",
                style: { textAlign: _vm.align }
              },
              [_vm._v("\n      " + _vm._s(_vm.header.intro) + "\n    ")]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.header.illustration
      ? _c("div", { staticClass: "illustration" }, [
          _c(_vm.header.illustration, { tag: "div" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09323b76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09323b76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headers/simple-title.vue
// module id = null
// module chunks = 